"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
var defaultTranslations = {
  old: "old",
  password: "password",
  minError: "Minimum",
  maxError: "Maximum",
  characters: "characters",
  new: "new",
  change: "change",
  confirm: "confirm",
  wrong: "wrong",
  back: "back",
  oldPasswordWarning: "Please note that you can't use your old password as your new password.",
  passwordsDoNotMatch: "Passwords do not match",
  changePasswordValidation: "Password must be at least 8 characters, contain 1 number and 1 uppercase character"
};
exports.defaultTranslations = defaultTranslations;